import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: '12px',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.02)' : '#ffffff',
    border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(10, 37, 64, 0.08)'}`,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.015)',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(10, 37, 64, 0.15)',
      transform: 'translateY(-1px)',
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  cardItem: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: '1.5',
    marginBlock: '2px',
  },
  divider: {
    marginBlock: theme.spacing(1),
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
  },
  timeline: {
    width: '70%',
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      '& .MuiTimelineItem-root': {
        '&::before': {
          display: 'none',
        },
      },
      '& .MuiTimelineContent-root': {
        padding: theme.spacing(1, 1, 1, 1.5),
      },
    },
  },
  tituloVestigio: {
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: '20px',
    marginBottom: '20px',
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}))
